import React from 'react';
import { useHomepageSettings } from '../../hooks/useHomepageSettings';

interface TrustBadge {
  icon: string;
  number: string;
  label: string;
}

const TrustBadges: React.FC = () => {
  const { data: settings, isLoading } = useHomepageSettings();

  const defaultBadges: TrustBadge[] = [
    { icon: '🏠', number: '500+', label: 'Homes Protected' },
    { icon: '⭐', number: '5.0', label: 'Average Rating' },
    { icon: '📅', number: '10+', label: 'Years Experience' },
    { icon: '🌴', number: '30A', label: 'Destin & Beyond' },
  ];

  const displayBadges = settings?.trustBadges?.badges || defaultBadges;
  const isEnabled = settings?.trustBadges?.enabled !== false; // Default to true

  // Don't render if disabled in CMS
  if (!isEnabled) {
    return null;
  }

  if (isLoading) {
    return (
      <section className="py-12 bg-white border-y border-sand-200">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-700"></div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-white border-y border-sand-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {displayBadges.map((badge, index) => (
            <div
              key={index}
              className="text-center group hover:scale-105 transition-transform duration-300"
            >
              <div className="text-4xl mb-2 group-hover:animate-bounce">
                {badge.icon}
              </div>
              <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-1">
                {badge.number}
              </div>
              <div className="text-sm md:text-base text-sand-700 font-medium">
                {badge.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
